import { render, staticRenderFns } from "./AutoFeedAlarms.vue?vue&type=template&id=f08e5cb0"
import script from "./AutoFeedAlarms.vue?vue&type=script&lang=ts"
export * from "./AutoFeedAlarms.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports